import React from 'react';
import gcal from './GCal.png';

const GoogleCalendarIcon = () => {
    return <img src={gcal} alt="G icon" width="48" height="30px" />;
};

export default GoogleCalendarIcon;